import _ from 'lodash'
import Vue from 'vue'

export default {
  setUnitByID(state, id) {
    state.unit = _.find(state.units, unit => {
      return unit.id === id
    })
  },
  setUnitFilters(state, value) {
    state.unitFilters = value
  },
  setUnitTypesFilter(state, value) {
    state.unitTypesFilter = value.reduce(function (accum, currrent, i) {
      accum.push({
        id: i,
        title: currrent,
      })

      return accum
    }, [])
  },
  setUnits(state, value) {
    state.units = value
  },
  setUnit(state, value) {
    if (!value.schedule) {
      value.schedule = {
        from: null,
        to: null,
      }
    }
    state.unit = value
  },
  setUnitStore(state, obj) {
    if (obj.id) {
      for (let i = 0; i < state.unit.stores.length; i++) {
        if (state.unit.stores[i].id === obj.id) {
          state.unit.stores[i].title = obj.title
          state.unit.stores[i].is_default = obj.is_default
          state.unit.stores[i].is_goods = obj.is_goods
        } else {
          state.unit.stores[i].is_default = state.unit.stores[i].is_default && !obj.is_default
          state.unit.stores[i].is_goods = state.unit.stores[i].is_goods && !obj.is_goods
        }
      }
    } else if (obj.ref) {
      for (let i = 0; i < state.unit.stores.length; i++) {
        if (state.unit.stores[i].title === obj.ref && !state.unit.stores[i].id) {
          state.unit.stores[i].title = obj.title
          state.unit.stores[i].is_default = obj.is_default
          state.unit.stores[i].is_goods = obj.is_goods
        } else {
          state.unit.stores[i].is_default = state.unit.stores[i].is_default && !obj.is_default
          state.unit.stores[i].is_goods = state.unit.stores[i].is_goods && !obj.is_goods
        }
      }
    } else {
      for (let i = 0; i < state.unit.stores.length; i++) {
        state.unit.stores[i].is_default = state.unit.stores[i].is_default && !obj.is_default
        state.unit.stores[i].is_goods = state.unit.stores[i].is_goods && !obj.is_goods
      }
      state.unit.stores.push({
        unit_id: state.unit.id,
        title: obj.title,
        is_default: obj.is_default,
        is_goods: obj.is_goods,
      })
    }
  },
  deleteUnitStore(state, obj) {
    if (obj.id) {
      for (let i = 0; i < state.unit.stores.length; i++) {
        if (state.unit.stores[i].id === obj.id) {
          state.unit.stores.splice(i, 1)
          if (state.unit.default_store_id === obj.id) {
            state.unit.default_store_id = null
          }
          if (state.unit.goods_store_id === obj.id) {
            state.unit.goods_store_id = null
          }
          break
        }
      }
    } else {
      for (let i = 0; i < state.unit.stores.length; i++) {
        if (state.unit.stores[i].title === obj.title) {
          state.unit.stores.splice(i, 1)
          if (state.unit.default_store_id === obj.title) {
            state.unit.default_store_id = null
          }
          if (state.unit.goods_store_id === obj.title) {
            state.unit.goods_store_id = null
          }
          break
        }
      }
    }
  },
  setUnitTypes(state, value) {
    state.unitTypes = value
  },
  setUnitNeighbours(state, value) {
    state.unitNeighbours = value
  },
  setUnitNeighboursLoad(state, value) {
    state.unitNeighboursLoad = value
  },
  selectUnitNeighbourByID(state, unitID) {
    let index = null
    let neighbour = _.find(state.unit.neighbours, (unit, i) => {
      index = i
      return unit.id === unitID
    })

    if (neighbour !== undefined) {
      state.unit.neighbours.splice(index, 1)
      return
    }

    neighbour = _.find(state.unitNeighbours, unit => {
      return unit.id === unitID
    })

    state.unit.neighbours.push(neighbour)
  },
  setUnitWindows(state, value) {
    state.unitWindows = value
  },
  setUnitSchedules(state, value) {
    state.unitSchedules = value
  },
  setUnitErrors(state, serviceErrors) {
    state.unitErrors = serviceErrors
  },
  setUnitWithoutSettingsPilki(state, bool) {
    state.unit.unitWithoutSettingsPilki = bool
  },
  setUnitField(state, { key, subKey = null, value }) {
    if (state.unit) {
      if (subKey) {
        Vue.set(state.unit[key], subKey, value)
      } else {
        Vue.set(state.unit, key, value)
      }
    }
  },
  pushUnitPromoServices(state, id) {
    if (!state.unit.promo_services) state.unit.promo_services = []
    state.unit.promo_services.push(id)
  },
  pushPromoServicesArray(state, obj) {
    state.unit.promo_services_array.push(obj)
  },
  pushPromoGoodsArray(state, obj) {
    state.unit.promo_goods_array.push(obj)
  },
  filterPromoServices(state, id) {
    state.unit.promo_services = state.unit.promo_services.filter(item => item !== id)
  },
  filterPromoServicesArray(state, id) {
    state.unit.promo_services_array = state.unit.promo_services_array.filter(item => item.id !== id)
  },
  setUnitSettingsField(state, obj) {
    if (state.unit) {
      if (state.unit.settings === null) {
        state.unit.settings = {}
      }

      if (obj.key === 'kkmSettings') {
        state.unit.settings = { ...state.unit.settings, [obj.key]: JSON.parse(obj.value) }
      } else {
        state.unit.settings = { ...state.unit.settings, [obj.key]: obj.value }
      }
    }
  },
  deleteUnit(state, id) {
    for (let i = 0; i < state.units.length; i++) {
      if (state.units[i].id === id) {
        state.units.splice(i, 1)
        break
      }
    }
  },
  changeUnit(state, payload) {
    for (let i = 0; i < state.units.length; i++) {
      if (state.units[i].id === payload.key) {
        const item = _.cloneDeep(payload.value)
        state.units.splice(i, 1, item)
        break
      }
    }
  },
  unshiftUnits(state, unit) {
    state.units.unshift(unit)
  },
  appendUnits(state, units) {
    state.units = state.units.concat(units)
  },
  setSearchStores(state, value) {
    state.searchStores = value
  },
  setWindowCancelMin(state, value) {
    state.unit.window_cancel_min = value
  },
  setWindowSplitIndent(state, value) {
    state.unit.window_split_indent = value
  },
  setWindowSplitMin(state, value) {
    state.unit.window_split_min = value
  },
  setNoWindowQuantumSize(state, value) {
    state.unit.no_window_quantum_size = value
  },
  setNoWindowPeriod(state, value) {
    state.unit.no_window_period = value
  },
  setUnitSettingsAvatarNeeded(state, isAvatarNeeded) {
    state.unit = { ...state.unit, isAvatarNeeded }
  },
  setUnitSettingsPortfolioNeeded(state, isPortfolioNeeded) {
    state.unit = { ...state.unit, isPortfolioNeeded }
  },
}
